import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, PHOTO_BASE_URL, PHOTO_BASE_URL_Admin } from '../../Api/config';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import tenderNotFoundImage from '../../Assets/images/notFoundImage.png';
const TopClients = () => {
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);
  const [clients, setClients] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch client data
    const fetchClients = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/user/visitor/client`);
        // console.log("Our clients:", response.data.data);
        setClients(response.data.data || []);
        
      } catch (err) {
        setError('Error fetching client data.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  useEffect(() => {
    if (clients.length > 0) {
      // Auto-slide functionality after clients are loaded
      const startAutoSlide = () => {
        intervalRef.current = setInterval(() => {
          setActiveIndex(prevIndex => (prevIndex + 1) % clients.length);
        }, 5000); // Slide every 5 seconds
      };

      startAutoSlide();

      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
      };
    }
  }, [clients]);

  useEffect(() => {
    if (sliderRef.current) {
      const containerWidth = sliderRef.current.offsetWidth;
      sliderRef.current.scrollTo({
        left: containerWidth * activeIndex,
        behavior: 'smooth',
      });
    }
  }, [activeIndex]);

  const handleScroll = direction => {
    setActiveIndex(prevIndex => {
      if (direction === 'left') {
        return prevIndex === 0 ? clients.length - 1 : prevIndex - 1;
      }
      return (prevIndex + 1) % clients.length;
    });

    // Pause and restart auto-slide
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setTimeout(() => {
        const startAutoSlide = () => {
          intervalRef.current = setInterval(() => {
            setActiveIndex(prevIndex => (prevIndex + 1) % clients.length);
          }, 5000);
        };
        startAutoSlide();
      }, 5000);
    }
  };

  const handleDotClick = index => setActiveIndex(index);

  if (loading) return <div className="text-center">Loading...</div>;
  // if (error) return <div className="text-center text-red-500">{error}</div>;
  if (error) return (
    <div className="w-full flex flex-col items-center justify-center py-10">
      <img
        src={tenderNotFoundImage}
        alt="No Tenders Found"
        className="w-80 h-80 object-contain"
      />
    </div>
  );

  return (
    <div className="relative container mx-auto  flex items-center justify-center  md:py-10 py-4">
      <button
        // className="absolute md:left-4 left-1 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full p-4 shadow-md hover:bg-gray-300 z-10"
        className="absolute left-1 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full p-2 md:p-4 lg:p-4 shadow-md hover:bg-gray-300 z-10"
        onClick={() => handleScroll('left')}
      >
        <FaChevronLeft />
      </button>

      <div className="container mx-auto px-4">
        <div className="text-center mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800">
            Our <span className="text-ServiceIconColor">Clients</span>
          </h2>
        </div>

        <div className="relative overflow-hidden ">
          <div
            ref={sliderRef}
            className="flex overflow-hidden snap-x snap-mandatory"
            style={{
              scrollBehavior: 'smooth',
              scrollbarWidth: 'none',
            }}
          >
            {clients.length > 0 ? (
              clients.map((client, index) => (
                <div
                  key={client.id}
                  className="snap-center flex-shrink-0 w-full md:w-1/3 p-4 "
                >
                  <div className="bg-white shadow-lg border rounded-lg p-6 text-center md:py-10 py-8">
                    <div className="flex justify-center mb-4">
                      <img
                        src={`${PHOTO_BASE_URL_Admin}${client.client_photo}`}
                        alt={client.name}
                        className="w-24 h-24 md:w-32 md:h-32 rounded-full border-4 border-gray-200"
                      />
                    </div>
                    <h3 className="text-lg md:text-xl 2xl:text-2xl font-semibold text-gray-800">
                      {client.name}
                    </h3>
                    <p className="text-xs md:text-sm 2xl:text-lg text-gray-600 mt-2 line-clamp-2">
                      {client.review}
                    </p>
                    <div className="mt-2">
                      <span
                        className="text-blue-500 cursor-pointer relative group"
                        // title={client.review}
                      >
                        See More
                        <div className="absolute hidden group-hover:block bg-gray-600 text-white text-sm rounded-lg shadow-lg p-2 z-20 bottom-full mt-2 left-1/2 transform -translate-x-1/2 w-64">
                          {client.review}
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full flex flex-col items-center justify-center">
                <img
                  src={tenderNotFoundImage}
                  alt="No Tenders Found"
                  className="w-80 h-80 object-contain"
                />
              </div>
            )}
          </div>
        </div>

        {/* Dots Navigation */}
        <div className="md:flex hidden justify-center mt-4">
          {clients.map((_, index) => (
            <button
              key={index}
              className={`w-3 h-3 rounded-full mx-1 ${
                index === activeIndex ? 'bg-gray-800' : 'bg-gray-400'
              }`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>

      <button
        className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full p-2 md:p-4 lg:p-4 shadow-md hover:bg-gray-300 z-10"
        onClick={() => handleScroll('right')}
      >
        <FaChevronRight />
      </button>
    </div>
  );
};

export default TopClients;

